import { Archive, Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from '@/components/ui/alert-dialog';

/**
 * AlertDialog de confirmation pour archiver une procédure
 */
export default function AlertDialogArchiveProcedure({ open, onOpenChange, onConfirm, isLoading }) {
    const { t } = useTranslation();
    return (
        <AlertDialog open={open} onOpenChange={onOpenChange}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle className="flex items-center gap-2">
                        <Archive className="h-5 w-5 text-destructive" />
                        {t('procedures:archiverLaProcedure')}
                    </AlertDialogTitle>
                    <AlertDialogDescription>
                        {t('procedures:etesVousSurDeVouloirArchiverCetteProcedure')}
                        <br />
                        <br />
                        {t('procedures:laProcedureNeSeraPlusVisibleDansLa')}
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel variant="soft" color="neutral" disabled={isLoading}>
                        {t('procedures:annuler')}
                    </AlertDialogCancel>
                    <AlertDialogAction variant="solid" color="destructive" onClick={onConfirm} disabled={isLoading}>
                        {isLoading ? (
                            <>
                                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                                {t('procedures:archivage')}
                            </>
                        ) : (
                            t('procedures:archiver')
                        )}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
